import { call, put } from "redux-saga/effects";
import { fetchPlayerActivity } from "../../../api";
import { profileActions } from "../../../actions/profile";

export function* fetchPlayerActivitySaga({ payload: { gameId, playerId } }) {
  console.log('Fetching player activity with:', { gameId, playerId });
  const res = yield call(fetchPlayerActivity, gameId, playerId);
  if (res.response) {
    yield put(profileActions.fetchPlayerActivitySuccess(res.response));
  } else if (res.error) {
    yield put(profileActions.fetchPlayerActivityFailure(res.error));
  }
} 